import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Select,
  message,
  Input,
  InputNumber,
} from "antd";
import "./StakeHolder.css";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
import UserContext from "../../UserContext/UserContext";
import { debounce } from "lodash";
const { TextArea } = Input;
class SelectStakeHolder extends Component {
  static contextType = UserContext;
  formRef = React.createRef();
  state = {
    invitationid: this.props.invitationid,
    vendorid: this.props.vendorid,
    data: [],
    resultlist: [
      { resultid: 5, result: "Шалгарсан" },
      { resultid: 4, result: "Шалгараагүй" },
    ],
    resultid: null,
    totalresult: null,
    approvedamount: null,
    note: "",
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    let totalresult = 0;
    API.get(
      "/getInvitationOfVendorListById?invitationid=" +
      this.state.invitationid +
      "&vendorid=" +
      this.state.vendorid
    ).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        if (response.data.retData.length > 0) {
          response.data.retData.map((el) => {
            totalresult = totalresult + el.result;
          });
          this.setState((prevState) => ({
            data: response.data.retData,
            note: response.data.retData[0].note,
            resultid: response.data.retData[0].status,
            approvedamount: response.data.retData[0].approvedamount,
            totalresult: totalresult,
            dkey: prevState.dkey + 1,
          }));
        }
      }
    });
  };
  onChangeResultID = (value) => {
    this.setState({ resultid: value });
  };
  onChangeResult = debounce((value, el) => {
    if (value > el.weight) {
      message.warning("Таны оруулсан оноо хувиарласан жингээс хэтэрч байна.");
    }
    let totalresult = 0;
    this.setState(
      this.state.data.map((item) => {
        item.result =
          item.criteriaid === el.criteriaid
            ? value
            : item.result;
        totalresult = totalresult + item.result;
      }),
    );
    this.setState((prevState) => ({
      totalresult: totalresult,
      dkey: prevState.dkey + 1,
    }));
  }, 1000);
  onChangeAmount = (value) => {
    this.setState({ approvedamount: value });
  };
  onChangeNote = (value) => {
    this.setState({ note: value });
  };
  onSave = () => {
    if (this.state.totalresult > 100) {
      message.warning("Таны оруулсан үнэлгээний нийт оноо 100-аас хэтэрч байна.")
    }
    else {
      let idata = [];
      this.state.data.map(r => {
        idata.push({
          invitationid: r.invitationid,
          vendorid: r.vendorid,
          criteriaid: r.criteriaid,
          result: (r.result ? r.result : 0)
        });
      });
      let body = {
        param: idata,
        status: this.state.resultid,
        note: this.state.note,
        createdby: this.context.username,
        approvedamount: (this.state.approvedamount ? this.state.approvedamount : 0)
      };
      API.post("/evalueteInvitationOfVendor", body).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          message.success("Амжилттай хадгаллаа.");
          this.props.showForm(false, 0);
        }
      });
    }
  };
  render() {
    return (
      <div id="stakeholder" key={this.state.dkey}>
        <Form
          className="formDrawer"
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <div className="MidLabel" style={{ marginBottom: 15 }}>
            Үнэлгээ оруулах
          </div>
          {this.state.data.map((el, index) => (
            <Row key={index} gutter={[16, 16]}>
              <Col span={24}>
                <Form.Item
                  style={{ fontWeight: 700 }}
                  label={el.criteriatypename + "/" + el.weight + "/"}
                  name={el.criteriatypename}
                  initialValue={el.result}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    onChange={(value) => this.onChangeResult(value, el)}
                    size="middle"
                    defaultValue={el.result}
                  />
                </Form.Item>
              </Col>
            </Row>
          ))}
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Нийт"
                name="Total"
                initialValue={this.state.totalresult}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  size="middle"
                  disabled
                  defaultValue={this.state.totalresult}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="MidLabel" style={{ marginBottom: 15 }}>
            Бусад
          </div>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Батлагдсан дүн"
                name="approvedamount"
                initialValue={this.state.approvedamount}
              >
                <InputNumber
                  placeholder="___._"
                  style={{ width: "100%" }}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  onChange={(value) => this.onChangeAmount(value)}
                  size="middle"
                  defaultValue={this.state.approvedamount}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Үр дүн"
                name="resultid"
                initialValue={
                  this.state.resultid === 3 ? null : this.state.resultid
                }
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  onChange={this.onChangeResultID}
                  defaultValue={
                    this.state.resultid === 3 ? null : this.state.resultid
                  }
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.resultlist &&
                    this.state.resultlist?.map((t, i) => (
                      <Select.Option key={i} value={t.resultid}>
                        {t.result}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Тайлбар"
                name="note"
                initialValue={this.state.note}
              >
                <TextArea
                  onChange={(e) => this.onChangeNote(e.target.value)}
                  rows={5}
                  defaultValue={this.state.note}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="buttonForm" label=" ">
            <Button
              type="primary"
              style={{
                width: "100%",
                backgroundColor: "#0358A7",
                borderRadius: 2,
                height: 40,
              }}
              htmlType="submit"
              onClick={this.onSave}
            >
              Хадгалах
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default withRouter(SelectStakeHolder);
